import React from "react"

export default function Form({ children, ...props }) {
  function handleSubmit(ev) {
    ev.preventDefault()
  }

  return (
    <form {...props} onSubmit={handleSubmit}>
      {children}
    </form>
  )
}
